import React from "react"
import { Lookup } from "../features/dashboard/Lookup";
import { Stack} from '@mui/system';
import { DashboardCard } from "../../../components";
import { Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useCenterFindQuery } from "../../../services/orgService/org-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AdecDashboard(){
    const {center} = useParams();
    const selectedCenter = useCenterFindQuery(center!);
    const navigate = useNavigate();

    return <React.Fragment>
        <Stack direction='row' justifyContent='space-around' alignItems='center'>                
            <Typography color='#62BCBD' variant="h5">{selectedCenter.data?.shortName}</Typography>
            <Lookup/>
            <Button variant='outlined' onClick={()=>navigate('/VerifyHome')} color='success'><FontAwesomeIcon icon={'arrow-left'}/><span className="ms-1">Go Back</span></Button>
        </Stack>

        <Stack direction='row' gap={2} justifyContent='center' alignItems='center'>
            <DashboardCard title='Worklist' queryParam="AdecBenefits" center={center!}/>
            <DashboardCard title='Assistance Request' queryParam="Assistance Needed" center={center!}/>
        </Stack>
    </React.Fragment>
}

export {AdecDashboard}